module.exports = __webpack_public_path__ + "static/media/hall-CSE.cee60342.svg";